import {
	getLigne,
	setService,
	getDirection,
	getService,
} from '../store/line-store.js'
import { Lignes, lineServicesName } from '../lines.js'
import { lineSelected } from '../utils/dom-utils.js'
import { ServiceButtonElement } from './service-button.js'

export class ServicesButtonsElement extends HTMLElement {
	constructor() {
		super()

		// this.shadow = this.attachShadow({ mode: 'open' })

		this.wrapper = document.createElement('div')

		const style = document.createElement('style')
		style.textContent = `
      button {
        background: #1e88e5;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 4px;
        cursor: pointer;
      }
      button:hover {
        background: #1565c0;
      }
    `

		this.appendChild(this.wrapper)
		this.wrapper.appendChild(style)

		document.addEventListener('ligne-selected', (event) => {
			this.wrapper.innerHTML = ''
			let lineName = getLigne()
			let servicesName = lineServicesName(lineName)
			const service = getService()
			if (!servicesName.includes(service)) {
				setService(servicesName[0])
			}
			if (servicesName.length > 1) {
				for (let e of servicesName || []) {
					let button = new ServiceButtonElement(e)
					this.wrapper.appendChild(button)
				}
			}
		})
	}
}

customElements.define('services-buttons', ServicesButtonsElement)
